import Cookies from 'js-cookie'

// 默認配置
const defaultOptions = {
  expires: 1, // 默認過期時間為 1 天
  path: '/',  // 默認路徑
  domain: '', // 默認域名
  secure: false, // 默認不使用 HTTPS
  sameSite: 'Lax' // 默認 SameSite 策略
}

// 合併配置
const mergeOptions = (options = {}) => ({ ...defaultOptions, ...options })

/**
 * 設置 cookie
 * @param {string} key - cookie 名稱
 * @param {string|object} value - cookie 值
 * @param {object} options - 可選配置項
 */
export const setCookie = (key, value, options = {}) => {
  const finalOptions = mergeOptions(options)
  if (typeof value === 'object') {
    value = JSON.stringify(value)
  }
  return Cookies.set(key, value, finalOptions)
}

/**
 * 獲取 cookie
 * @param {string} key - cookie 名稱
 * @param {boolean} parseJson - 是否解析 JSON
 * @returns {string|object|null}
 */
export const getCookie = (key, parseJson = false) => {
  const value = Cookies.get(key)
  if (value && parseJson) {
    try {
      return JSON.parse(value)
    } catch (e) {
      return value
    }
  }
  return value
}

/**
 * 刪除 cookie
 * @param {string} key - cookie 名稱
 * @param {object} options - 可選配置項
 */
export const removeCookie = (key, options = {}) => {
  const finalOptions = mergeOptions(options)
  return Cookies.remove(key, finalOptions)
}

/**
 * 檢查 cookie 是否存在
 * @param {string} key - cookie 名稱
 * @returns {boolean}
 */
export const hasCookie = (key) => {
  return Cookies.get(key) !== undefined
}

/**
 * 獲取所有 cookie
 * @returns {object}
 */
export const getAllCookies = () => {
  return Cookies.get()
}

// 導出默認配置，方便外部修改
export const cookieConfig = {
  setDefaultOptions(options) {
    Object.assign(defaultOptions, options)
  }
}

// 為了兼容性，也導出一個默認對象
export default {
  set: setCookie,
  get: getCookie,
  remove: removeCookie,
  has: hasCookie,
  getAll: getAllCookies,
  config: cookieConfig
} 